<template lang="html">
 <div class="map">
    <div class="container">
      <!--
        amap-manager： 地图管理对象
        vid：地图容器节点的ID
        zooms： 地图显示的缩放级别范围，在PC上，默认范围[3,18]，取值范围[3-18]；在移动设备上，默认范围[3-19]，取值范围[3-19]
        center： 地图中心点坐标值
        plugin：地图使用的插件
        events： 事件
      -->
      <el-amap class="amap-box"
        :amap-manager="amapManager"
        :vid="'amap-vue'"
        :zoom="zoom"
        :plugin="plugin"
        :center="center"
        :events="events"
      >
        <el-amap-polyline :path="path" lineJoin="round"></el-amap-polyline>
        <!-- 标记 -->
        <el-amap-marker v-for="(marker, index) in markers" :position="marker.position" :key="index" :events="marker.events"></el-amap-marker>
        <el-amap-text
         v-for="(marker, index) in markers"
         :key="'text' + index"
         :text="marker.text"
         :offset="marker.offset"
         :position="marker.position"
       ></el-amap-text>
        <el-amap-info-window
          v-if="window"
          :position="window.position"
          :visible="window.visible"
          :content="window.content"
          :offset="window.offset"
        ></el-amap-info-window>
      </el-amap>
      <div style="display:none">
        <mapInfo ref="mapInfo" :templateName="window.templateName" :equipment_model="window.equipment_model" :serialNumber="window.serialNumber" :time="window.time" :model="window.model"/>
      </div>
    </div>
 </div>
</template>

<script>
import DataService from '@/api/data'
import mapInfo from '@/components/mapInfo/index.vue'
import {utils} from '@/utils/index'
import { AMapManager, lazyAMapApiLoaderInstance } from 'vue-amap'
let amapManager = new AMapManager()
export default {
  name:'AMap',
  components:{
    mapInfo
  },
  data() {
    let self = this
    return {
      path:[
        [116.368904, 39.913423],
        [116.382122, 39.901176],
        [116.387271, 39.912501],
        [116.398258, 39.904600]
      ],
      address: null,
      searchKey: '',
      amapManager,
      markers: [],
      windows:[],
      window:'',
      searchOption: {
        city: '全国',
        citylimit: true
      },
      pointMarker:[],
      center: [112.938888,36.228272],
      zoom: 5,
      lng: 0,
      lat: 0,
      loaded: false,
      markerRefs: [],
      events: {
        init(o) {
          setTimeout(() => {
            let cluster = new AMap.MarkerClusterer(o, self.markerRefs,{
              gridSize: 80,
              renderCluserMarker: self._renderCluserMarker
            });
          }, 1000);
        }
      },
      // 一些工具插件
      plugin: [
        {
          pName: 'Geocoder',
          events: {
            init (o) {
              //console.log("一些工具插件--地址"+o.getAddress())
            }
          }
        },
        {
          // 工具栏
          pName: 'ToolBar',
          events: {
            init(instance) {
               //console.log("工具栏:"+instance);
            }
          }
        },
        {
          // 鹰眼
          pName: 'OverView',
          events: {
            init(instance) {
               //console.log("鹰眼:"+instance);
            }
          }
        },
        {
          // 地图类型
          pName: 'MapType',
          defaultType: 0,
          events: {
            init(instance) {
               //console.log("地图类型:"+instance);
            }
          }
        },
      ]
    }
  },
  methods: {
    _renderCluserMarker(context) {
      const count = this.markers.length;
      let div = document.createElement('div');
      let bgColor = 'hsla(200,100%,50%,0.7)';
      let fontColor = 'hsla(0,100%,20%,1)';
      let borderColor = 'hsla(200,100%,40%,1)';
      let shadowColor = 'hsla(200,100%,50%,1)';
      div.style.backgroundColor = bgColor
      let size = Math.round(30 + Math.pow(context.count/count,1/5) * 20);
      div.style.width = div.style.height = size+'px';
      div.style.border = 'solid 1px '+ borderColor;
      div.style.borderRadius = size/2 + 'px';
      div.style.boxShadow = '0 0 1px '+ shadowColor;
      div.innerHTML = context.count;
      div.style.lineHeight = size+'px';
      div.style.color = fontColor;
      div.style.fontSize = '14px';
      div.style.textAlign = 'center';
      context.marker.setOffset(new AMap.Pixel(-size/2,-size/2));
      context.marker.setContent(div)
    },
    getMapInfo(){
      let data = []
      DataService.getMapInfo({
        user_id:this.$store.state.user_id
      }).then(res=>{
        res.data.forEach(el=>{
          if(el.longitude != null && el.latitude != null){
            data.push(el)
          }
        })
        this.pointMarker = data;
        this.point();
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    point(){
      let markers = [];
      let windows=[]
      let that=this
      this.pointMarker.forEach((item,index)=>{
        markers.push({
          position: [item.longitude,item.latitude],
          text:item.serial_number,
          offset:[0,16],//窗体偏移
          // icon:item.url, //不设置默认蓝色水滴
          events: {
            click() {
              that.windows.forEach(window => {
                window.visible = false; //关闭窗体
              });
              that.window = that.windows[index];
              that.center = that.window.position;
              that.zoom = 18;
              that.$nextTick(() => {
                that.window.visible = true;//点击点坐标，出现信息窗体
              });
            },
            init(o) {
              that.markerRefs.push(o);
            }
          }
        })
        windows.push({
          position: [item.longitude,item.latitude],
          content:that.$refs.mapInfo.$el,//内容
          offset:[5,-15],//窗体偏移
          visible: false,//初始是否显示
          serialNumber:item.serial_number,
          // time:utils.formatDate(item.time),
          templateName:item.templateName,
          equipment_model:item.customer_equipment_model
        })
      })
      //  加点
      this.markers = markers;
      console.log(this.markers)
      //加弹窗
      this.windows=windows
      console.log(this.windows)
    },
  },
  created(){
    this.getMapInfo();
  },
  updated(){
    console.log(this.window)
  }
}
</script>

<style lang="css" scoped>
.map{
  width:100%;
  height:calc(100vh - 60px);
}
.container {
  width: 100%;
  height: 100%;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  border: 1px solid #999;
}
.search-box {
  position: absolute;
  z-index: 5;
  width: 30%;
  left: 13%;
  top: 10px;
  height: 30px;
}
.search-box input {
  float: left;
  width: 80%;
  height: 100%;
  border: 1px solid #409EFF;
  padding: 0 8px;
  outline: none;
}
.search-box button {
  float: left;
  width: 20%;
  height: 100%;
  background: #409EFF;
  border: 1px solid #409EFF;
  color: #fff;
  outline: none;
}
.tip-box {
  width: 100%;
  max-height: 260px;
  position: absolute;
  top: 30px;
  overflow-y: auto;
  background-color: #fff;
}
</style>
